import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { planBuilderQuantityUpdated } from '../../../actions/PlanBuilderActions';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppDispatch, useAppSelector } from '../../../reducers';
import { planBuilderEligibleAddonsSelector } from '../../../selectors/PlanBuilderSelectors';
import { trackPlanBuilderInteraction } from '../../../v2/utils/tracking/trackingEventUtils';
import { FlushedTitle } from '../SharedComponents';
import ExpandableChecklist from './ExpandableChecklist';
import { jsx as _jsx } from "react/jsx-runtime";
const AddonsPickerList = ({
  defaultOpen = false
}) => {
  const dispatch = useAppDispatch();
  const isAppReady = useGlobalLoading();
  const eligibleAddOnsSkuIds = useAppSelector(state => {
    if (!isAppReady) {
      return [];
    }
    const eligibleAddons = planBuilderEligibleAddonsSelector(state);
    return (eligibleAddons === null || eligibleAddons === void 0 ? void 0 : eligibleAddons.skuIds) || [];
  });
  const updateSelectedSkus = ({
    value,
    skuId,
    apiName,
    previousValue
  }) => {
    dispatch(planBuilderQuantityUpdated({
      skuId,
      quantity: value
    }));
    trackPlanBuilderInteraction({
      component: 'AddonsAndServicesPickerList',
      // this is named AddonsAndServicesPickerList to preserve historical tracking
      action: value > previousValue ? 'added item' : 'removed item',
      skuId,
      productName: apiName
    });
  };
  const trackAccordionInteraction = (use, isAccordionOpen) => {
    trackPlanBuilderInteraction({
      component: 'AddonsAndServicesPickerList',
      // this is named AddonsAndServicesPickerList to preserve historical tracking
      action: isAccordionOpen ? `opened ${use}` : `closed ${use}`
    });
  };
  if (!isAppReady || eligibleAddOnsSkuIds.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(ExpandableChecklist, {
    title: /*#__PURE__*/_jsx(FlushedTitle, {
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.addonsAndServices.addons.title"
      })
    }),
    subtext: /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.addonsAndServices.addons.text"
      })
    }),
    skuIds: eligibleAddOnsSkuIds,
    use: "addons",
    onSelectedChange: updateSelectedSkus,
    trackAccordionInteraction: trackAccordionInteraction,
    defaultOpen: defaultOpen
  });
};
export default AddonsPickerList;